import { securityRoles } from "./SecurityRoles.slice";

export const securityRolesActions = { ...securityRoles.actions };
